<!-- Список групп, в которые одновременно входит ресурс роли. -->
<template>
  <div class="permission-role-group-badges">
    <span
      v-for="resourceGroup in groups"
      :key="resourceGroup.group"
      class="permission-role-group-badge"
    >
      <span v-if="resourceGroup.emoji">
        {{ resourceGroup.emoji }}
      </span>
      {{ resourceGroup.label }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PermissionRoleGroupBadges",
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.permission-role-group-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: auto;
}

.permission-role-group-badge {
  padding: 2px 8px;
  border-radius: 99px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}
</style>
